// extracted by mini-css-extract-plugin
export default {"top":"HeaderPurOrder_top__KPfGS","box":"HeaderPurOrder_box__0q4tx","addButton":"HeaderPurOrder_addButton__czTa7"};